<template>
  <!-- 首次课计划提醒 -->
  <div class="popup" style="background: #fff">
    <div style="display: flex; justify-content: space-around; font-weight: 800">
      <div
        style="
          width: 200px;
          background-color: rgb(251 201 30);
          height: 150px;
          border-radius: 10px;
          margin-left: -140px;
        "
      >
        <div style="display: flex; padding-top: 40px; padding-left: 16px">
          教师未完成总数:{{ dataTop.teacherNotOk }}
        </div>
        <div style="display: flex; padding-top: 20px; padding-left: 16px">
          教师已完成总数:{{ dataTop.teacherOk }}
        </div>

        <div style=" margin-left: 219px; margin-top: -93px;">
        <div
          style="
            width: 200px;
            background-color: rgb(233 149 150);
            height: 30px;
            border-radius: 10px;
            padding: 5px 0px;
            margin-bottom: 10px;
            text-align: start;
            line-height: 26px;
            padding-left: 10px;
          "
        >
          教师待提交:{{ dataTop.teacherDaiTiJiao }}
        </div>
        <div
          style="
            width: 200px;
            background-color: rgb(221 152 239);
            height: 30px;
            border-radius: 10px;
            padding: 5px 0px;
            margin-bottom: 10px;
            text-align: start;
            line-height: 26px;
            padding-left: 10px;
          "
        >
          教师被驳回:{{ dataTop.teacherBieBoHui }}
        </div>
        <div
          style="
            width: 200px;
            background-color: rgb(94 190 243);
            height: 30px;
            border-radius: 10px;
            padding: 5px 0px;
            margin-bottom: 10px;
            text-align: start;
            line-height: 26px;
            padding-left: 10px;
          "
        >
          学管审核中:{{ dataTop.xueguanshenhezhong }}
        </div>
      </div>


      </div>



      <div
        style="
          width: 200px;
          background-color: rgb(125 219 218);
          height: 150px;
          border-radius: 10px;
          margin-left: -40px;
        "
      >
        <div style="display: flex; padding-top: 40px; padding-left: 16px">
          销售待完成总数:{{ dataTop.marketNotOk }}
        </div>
        <div style="display: flex; padding-top: 20px; padding-left: 16px">
          销售已完成总数:{{ dataTop.marketOk }}
        </div>

        <div style="margin-left: 210px;margin-top: -70px;">
        <div
          style="
            width: 200px;
            background-color: rgb(156 227 142);
            height: 30px;
            border-radius: 10px;
            padding: 5px 0px;
            margin-bottom: 10px;
            text-align: start;
            line-height: 26px;
            padding-left: 10px;
          "
        >
        首次课成功:{{ dataTop.firstOk }}
        </div>
        <div
          style="
            width: 200px;
            background-color: rgb(239 192 136);
            height: 30px;
            border-radius: 10px;
            padding: 5px 0px;
            margin-bottom: 10px;
            text-align: start;
            line-height: 26px;
            padding-left: 10px;
          "
        >
        首次课未成功:{{ dataTop.firstNotOk }}
        </div>
      </div>
      </div>



    </div>

    <p class="popup_top" style="text-align: left; margin-top: 15px">
      <i class="el-icon-warning" style="color: #0e99db; margin-right: 5px"></i
      ><span style="margin-right: 20px">首次课提示</span>
    </p>
    <el-form class="demo-form-inline" label-width="100px">
      <!-- <el-form-item label="日期:">
        <el-date-picker type="date" placeholder="选择日期" v-model="obj.classFirstDate" style="width: 100%;"
          value-format="yyyy-MM-dd" clearable>
        </el-date-picker>
      </el-form-item> -->

      <!-- <el-form-item label="学生姓名:">
        <el-select
          placeholder="请选择学生"
          v-model="obj.studentId"
          style="width: 100%"
          clearable
          filterable
        >
          <el-option
            v-for="item in studentArr"
            :key="item.id"
            :value="item.id"
            :label="item.realname"
          >
          </el-option>
        </el-select>
      </el-form-item> -->

      <el-form-item label="线下学员:">
        <el-select
          placeholder="请选择学生"
          v-model="obj2.studentId"
          style="width: 100%"
          clearable
          filterable
        >
          <el-option
            v-for="item in studentArr"
            :key="item.id"
            :value="item.id"
            :label="item.realname"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="规划学员:">
        <el-select
          placeholder="请选择学生"
          v-model="obj2.studentId1"
          style="width: 100%"
          clearable
          filterable
        >
          <el-option
            v-for="item in studentArr1"
            :key="item.id"
            :value="item.id"
            :label="item.realname"
          >
          </el-option>
        </el-select>
      </el-form-item>


      <el-form-item label="首次授课老师:">
        <el-select
          placeholder="请选择"
          v-model="obj.teacherId"
          style="width: 100%"
          clearable
          filterable
        >
          <el-option
            v-for="item in teacherArr"
            :key="item.id"
            :value="item.id"
            :label="item.realname"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="科目:">
        <el-select
          placeholder="请选择"
          v-model="obj.subject"
          style="width: 100%"
          clearable
          filterable
        >
          <el-option
            v-for="item in subjectArr"
            :key="item.id"
            :value="item.id"
            :label="item.categoryName"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="首次课计划教师完成情况:" label-width="200px">
        <el-select placeholder="请选择" v-model="obj.accomplish" style="width:100%;">
          <el-option v-for="item in planTeacher" :key="item.value" :value="item.value" :label="item.label">
          </el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label="审核状态:">
        <el-select
          placeholder="请选择"
          v-model="obj.auditStatus"
          style="width: 100%"
          clearable
          filterable
        >
          <el-option
            v-for="item in auditStatusArr"
            :key="item.value"
            :value="item.value"
            :label="item.name"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="学生类型:">
        <el-select
          placeholder="请选择"
          v-model="obj.classType"
          style="width: 100%"
          clearable
          filterable
        >
          <el-option
            v-for="item in marketArr_ss"
            :key="item.value"
            :value="item.value"
            :label="item.label"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="销售完成情况:">
        <el-select
          placeholder="请选择"
          v-model="obj.marketSuccess"
          style="width: 100%"
          clearable
          filterable
        >
          <el-option
            v-for="item in marketSuccessArr"
            :key="item.value"
            :value="item.value"
            :label="item.label"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="跟进助理:">
          <el-select
            placeholder="请选择跟进助理"
            v-model="obj.assistantId"
            style="width: 100%"
            clearable
            filterable
          >
            <el-option
              v-for="item in teacherArrr"
              :key="item.id"
              :value="item.id"
              :label="item.realname"
            >
            </el-option>
          </el-select>
        </el-form-item>

      <el-form-item label="首次课成功情况:" label-width="130px">
        <el-select placeholder="请选择" v-model="obj1.success" style="width:100%;">
          <el-option v-for="item in firstClassState" :key="item.value" :value="item.value" :label="item.label">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="首次课日期:">
        <el-date-picker
          v-model="Time_start_end"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </el-form-item>
      
      <el-form-item label="所在地域:" >
            <el-select v-model="obj.regionName" clearable filterable placeholder="请选择所在地域"  style="width: 100%;">
              <el-option v-for="item in optionsListt" :key="item.id" :label="item.dictValue"
              :value="item.dictType"></el-option>
            </el-select>
      </el-form-item>

      <el-form-item label="诊断师:" >
            <el-select v-model="obj.diagnoseTeacherId" clearable filterable placeholder="请选择诊断师"  style="width: 100%;">
              <el-option v-for="item in optionsListt111" :key="item.teacherId" :label="item.teacherName"
              :value="item.teacherId"></el-option>
            </el-select>
      </el-form-item>

      <el-form-item label="创建日期:">
        <el-date-picker
          v-model="Time_start_ends"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </el-form-item>

      <el-form-item label="规划师:" >
            <el-select v-model="obj.projectTeacherId" clearable filterable placeholder="请选择规划师"  style="width: 100%;">
              <el-option v-for="item in optionsListt1111" :key="item.teacherId" :label="item.teacherName"
              :value="item.teacherId"></el-option>
            </el-select>
      </el-form-item>


      <el-form-item label="学科组:" >
            <el-select v-model="obj.SubjectGroup" clearable filterable placeholder="请选择学科组"  style="width: 100%;">
              <el-option v-for="item in SubjectGroupList" :key="item.teacherId" :label="item.teacherName"
              :value="item.teacherId"></el-option>
            </el-select>
      </el-form-item>


      <el-form-item label="是否有效:" >
         <el-select v-model="obj.isLose" clearable filterable placeholder="请选择是否有效"  style="width: 100%;">
           <el-option v-for="item in isValidList" :key="item.id" :label="item.name" :value="item.teacherId"></el-option>
         </el-select>
      </el-form-item>


      <!-- <el-form-item></el-form-item>
      <el-form-item></el-form-item> -->
      <!-- <el-form-item label="首次课成功情况:" label-width="200px">
        <el-select placeholder="请选择" v-model="obj.success" style="width:100%;">
          <el-option v-for="item in firstClassState" :key="item.value" :value="item.value" :label="item.label">
          </el-option>
        </el-select>
      </el-form-item> -->
      <!-- <el-form-item>
        <el-button type="primary" @click="searchBtn">搜索</el-button>
        <el-button type="primary" @click="clearBtn">清空</el-button>
        <el-button type="primary" @click="historyBtn">首次课历史记录</el-button>
      </el-form-item> -->
    </el-form>
    <p style="width: 98%; text-align: right">
      <el-button
        type="primary"
        @click="searchBtn"
        size="small"
        class="btns"
        icon="el-icon-search"
        >搜索</el-button
      >
      <el-button
        type="primary"
        @click="clearBtn"
        size="small"
        class="btns"
        icon="el-icon-close"
        >清空</el-button
      >
      <el-button type="primary"  @click="downloadBtn" class="btns" size="small" icon="el-icon-download">导出</el-button >
      <!-- <el-button
        type="primary"
        @click="historyBtn"
        size="small"
        class="btns"
        icon="el-icon-tickets"
        >首次课历史记录</el-button
      > -->
    </p>
    <el-table
      :data="tableData"
      stripe
      height="500"
      style="width: 99%; margin: 20px auto"
      border
      :header-cell-style="{
        background: '#fafafa',
        'text-align': 'center',
      }"
      :cell-style="{ 'text-align': 'center' }"
    >
      <el-table-column prop="createTime" label="创建时间" width="250"> </el-table-column>
      <el-table-column prop="regionName" label="所在地域" width="100"></el-table-column>
      <el-table-column prop="studentName" label="学生姓名"> </el-table-column>
      <el-table-column prop="classFirstDate" label="首次课日期" width="180">
      </el-table-column>

      <!-- <el-table-column prop="auditDate" label="审核时间"> </el-table-column> -->
      <!-- <el-table-column prop="marketDate" label="销售完成时间"> </el-table-column> -->
      <!-- <el-table-column prop="commitDate" label="提交时间"> </el-table-column> -->
      <!-- <el-table-column prop="createTime" label="创建时间"> </el-table-column> -->

      <el-table-column prop="diagnoseTeacherName" label="诊断师"> </el-table-column>
      <el-table-column prop="projectTeacherName" label="规划师"> </el-table-column>


      <el-table-column prop="teacherName" label="首次课教师" width="250"> </el-table-column>
      <el-table-column prop="assistantName" label="跟进助理"> </el-table-column>
      <el-table-column prop="subjectName" label="科目"> </el-table-column>
      <!-- <el-table-column prop="accomplish" label="首次课计划教师完成情况">
        <template slot-scope="scope">
          <span v-if="scope.row.accomplish == 1">未完成</span>
          <span v-else>已完成</span>
        </template>
      </el-table-column> -->
      <el-table-column prop="auditStatus" label="审核状态">
        <template slot-scope="scope">
          <span v-if="scope.row.auditStatus == -1">被驳回</span>
          <span v-if="scope.row.auditStatus == -2">待提交</span>
          <span v-if="scope.row.auditStatus == 0">审核中</span>
          <span v-if="scope.row.auditStatus == 1">已完成</span>
        </template>
      </el-table-column>
      <el-table-column prop="commitDate" label="提交时间" width="250"> </el-table-column>
      <el-table-column prop="auditDate" label="审核时间" width="250"> </el-table-column>
      <el-table-column prop="classType" label="学生类型">
          <template slot-scope="scope">
            <span v-if="scope.row.classType == 1">规划</span>
            <span v-if="scope.row.classType == 2">线下</span>
            <span v-if="scope.row.classType == 3">纯补课</span>
          </template>
      </el-table-column>

      <el-table-column prop="success" label="首次课完成情况" width="250">
          <template slot-scope="scope">
            <span v-if="scope.row.success == 1">已完成</span>
            <span v-else-if="scope.row.success == 0">未完成</span>
            <span v-else>未知</span>
          </template>
      </el-table-column>

      <el-table-column prop="url" label="完成情况截图" width="120">
        <!-- <template slot-scope="scope">
          <img
            v-if="scope.row.url"
            :src="scope.row.url"
            :alt="scope.row.url"
            style="width: 100%; height: 100%"
          />
        </template> -->
        <template slot-scope="scope">
          <img
            v-if="scope.row.url"
            :src="scope.row.url"
            :alt="scope.row.url"
            style="width: 100%; height: 100%"
            @click="handleImgClick(scope.row.url)"
          />
        </template>
      </el-table-column>
      <el-table-column label="首次课计划" width="180">
        <template slot-scope="scope">
          <el-button type="text" @click="detail(scope.row.id)">详情</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="classDate" label="上课时间" width="180"> </el-table-column>
      <el-table-column prop="address" label="销售完成情况" width="250px">
        <template slot-scope="scope">
          <el-radio-group
            v-model="scope.row.marketSuccess"
            @change="changeMarke(scope.row)"
          >
            <el-radio :label="2">已完成</el-radio>
            <el-radio :label="1" :disabled="scope.row.marketSuccess == 2"
              >未完成</el-radio
            >
          </el-radio-group>
        </template>
      </el-table-column>
      <el-table-column label="审批详情">
        <template slot-scope="scope">
          <el-button type="text" @click="handleClickDetail(scope.row)">详情</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="address" width="330px" label="首次课成功情况">
        <template slot-scope="scope">
          <el-radio-group
            v-model="scope.row.success"
            @change="handleStateChange(scope.row)"
            :disabled="scope.row.marketSuccess == 1"
          >
            <el-radio :label="0">未成功</el-radio>
            <el-radio :label="1">已成功</el-radio>
            <!-- <el-radio :label="2">未知</el-radio> -->
          </el-radio-group>
        </template>
      </el-table-column>
      <el-table-column prop="marketDate" label="销售完成时间" width="250"> </el-table-column>
      <el-table-column prop="remark" width="250px" label="成功/未成功原因"></el-table-column>

      <el-table-column prop="isLose" width="220px" label="是否有效">
        <template slot-scope="scope">
          <el-radio-group  v-model="scope.row.isLose" @change="handleStateChange1(scope.row)" :disabled="adminType === 2">
            <el-radio :label="0">有效</el-radio>
            <el-radio :label="1">无效</el-radio>
          </el-radio-group>
        </template>
      </el-table-column>

    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="obj.pageNo"
      :page-size="obj.pageSize"
      layout="total, prev, pager, next"
      :total="total"
    >
    </el-pagination>
    <el-dialog
      title="未成功原因"
      :visible.sync="flog"
      width="30%"
      :before-close="handleClose"
    >
      <el-form label-width="50px">
        <el-form-item label="原因">
          <el-input placeholder="请输入" maxlength="200" :autosize="{ minRows: 5, maxRows: 5}" show-word-limit	 type="textarea"  v-model="obj.remark"></el-input
        ></el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="saveRemark">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="成功原因"
      :visible.sync="flogs"
      width="30%"
      :before-close="handleCloses"
    >
      <el-form label-width="50px">
        <el-form-item label="原因">
          <el-input placeholder="请输入" maxlength="200"  :autosize="{ minRows: 5, maxRows: 5}" show-word-limit	 type="textarea"  v-model="obj.remark"></el-input
        ></el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCloses">取 消</el-button>
        <el-button type="primary" @click="saveRemark">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 详情弹窗 -->
    <el-dialog title="详情" :visible.sync="detailDia" width="50%">
      <el-form label-width="100px">
        <el-form-item label="首次课计划">
          <el-input
            type="textarea"
            :autosize="{ minRows: 4, maxRows: 6 }"
            placeholder="请输入内容"
            v-model="content"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="相关资料" style="text-align: left">
          <ul style="list-style-type: none">
            <li v-for="(item, index) in fileList" :key="index">
              <!-- <a :href="item.url" download="file">{{ item.name }}</a> -->
              <div style="color: #007bff;" @click="handleUrl(item.url,item.name)">{{ item.name }}</div>
            </li>
          </ul>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="detailDia = false">取 消</el-button>
        <el-button type="primary" @click="detailDia = false">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 首次课历史记录 -->
    <el-dialog
      title="首次课历史记录"
      :visible.sync="firstClassIsshow"
      width="90%"
    >
      <el-form class="demo-form-inline" label-width="100px">
        <el-form-item label="学生姓名:">
          <el-select
            placeholder="请选择学生"
            v-model="objBottom.studentId"
            style="width: 100%"
            clearable
            filterable
          >
            <el-option
              v-for="item in studentArr"
              :key="item.id"
              :value="item.id"
              :label="item.realname"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="首次授课老师:">
          <el-select
            placeholder="请选择规划师"
            v-model="objBottom.teacherId"
            style="width: 100%"
            clearable
            filterable
          >
            <el-option
              v-for="item in teacherArr"
              :key="item.id"
              :value="item.id"
              :label="item.realname"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="科目:">
          <el-select
            placeholder="请选择"
            v-model="objBottom.subject"
            style="width: 100%"
            clearable
            filterable
          >
            <el-option
              v-for="item in subjectArr"
              :key="item.id"
              :value="item.id"
              :label="item.categoryName"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="首次课计划教师完成情况:" label-width="200px">
          <el-select placeholder="请选择" v-model="objBottom.accomplish" style="width:100%;">
            <el-option v-for="item in planTeacher" :key="item.value" :value="item.value" :label="item.label">
            </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="审核状态:">
          <el-select
            placeholder="请选择"
            v-model="objBottom.auditStatus"
            style="width: 100%"
            clearable
            filterable
          >
            <el-option
              v-for="item in auditStatusArr_s"
              :key="item.value"
              :value="item.value"
              :label="item.name"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="销售完成情况:">
          <el-select
            placeholder="请选择"
            v-model="objBottom.marketSuccess"
            style="width: 100%"
            clearable
            filterable
          >
            <el-option
              v-for="item in marketSuccessArr"
              :key="item.value"
              :value="item.value"
              :label="item.label"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="跟进助理:">
          <el-select
            placeholder="请选择跟进助理"
            v-model="objBottom.assistantId"
            style="width: 100%"
            clearable
            filterable
          >
            <el-option
              v-for="item in teacherArr"
              :key="item.id"
              :value="item.id"
              :label="item.realname"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="首次课成功情况:" label-width="115px">
          <el-select
            placeholder="请选择"
            v-model="success"
            style="width: 100%"
            clearable
            filterable
          >
            <el-option
              v-for="item in firstClassState"
              :key="item.value"
              :value="item.value"
              :label="item.label"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="日期:">
          <el-date-picker
            v-model="classFirstDate"
            style="width: 100%"
            clearable
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd" >
          </el-date-picker>
        </el-form-item>

        <el-form-item label="学生类型:">
          <el-select
            placeholder="请选择"
            v-model="objBottom.classType"
            style="width: 100%"
            clearable
            filterable
          >
            <el-option
              v-for="item in marketArr_ss"
              :key="item.value"
              :value="item.value"
              :label="item.label"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="searchBtns">搜索</el-button>
          <el-button type="primary" @click="clearBtns">清空</el-button>
        </el-form-item>
      </el-form>
      <el-table
        :data="tableData1"
        stripe
        style="width: 99%; margin: 20px auto"
        border
        :header-cell-style="{
          background: '#fafafa',
          'text-align': 'center',
        }"
        :cell-style="{ 'text-align': 'center' }"
      >
        <el-table-column prop="studentName" label="学生姓名"> </el-table-column>
        <el-table-column prop="classFirstDate" label="首次课日期" width="120px">
        </el-table-column>
        <el-table-column prop="teacherName" label="首次课教师" width="120px">
        </el-table-column>
        <el-table-column prop="classType" label="学生类型">
          <template slot-scope="scope">
            <span v-if="scope.row.classType == 1">规划</span>
            <span v-if="scope.row.classType == 2">线下</span>
            <span v-if="scope.row.classType == 3">纯补课</span>
          </template>
        </el-table-column>
        <el-table-column prop="subjectName" label="科目"> </el-table-column>
        <!-- <el-table-column prop="accomplish" width="110px" label="首次课计划教师完成情况">
          <template slot-scope="scope">
            <span v-if="scope.row.accomplish == 1">未完成</span>
            <span v-else>已完成</span>
          </template>
        </el-table-column> -->
        <el-table-column prop="auditStatus" label="审核状态">
          <template slot-scope="scope">
            <span v-if="scope.row.auditStatus == -1">被驳回</span>
            <span v-if="scope.row.auditStatus == -2">待提交</span>
            <span v-if="scope.row.auditStatus == 0">审核中</span>
            <span v-if="scope.row.auditStatus == 1">已完成</span>
          </template>
        </el-table-column>
        <el-table-column label="首次课计划">
          <template slot-scope="scope">
            <el-button type="text" @click="detail(scope.row.id)"
              >详情</el-button
            >
          </template>
        </el-table-column>
        <el-table-column prop="url" label="完成情况截图" width="150">
          <template slot-scope="scope">
            <img
               v-if="scope.row.url"
              :src="scope.row.url"
              :alt="scope.row.url"
              style="width: 100%; height: 100%"
            />
          </template>
        </el-table-column>
        <el-table-column prop="classDate" label="上课时间" width="150px">
        </el-table-column>
        <el-table-column prop="address" label="销售完成情况" width="130px">
          <template slot-scope="scope">
            <span v-if="scope.row.marketSuccess == 2">已完成</span>
            <span v-if="scope.row.marketSuccess == 1">未完成</span>
            <span v-else></span>
          </template>
        </el-table-column>
        <el-table-column prop="success" width="130px" label="首次课成功情况">
          <template slot-scope="scope">
            <span v-if="scope.row.success == 0">未成功</span>
            <span v-if="scope.row.success == 1">已成功</span>
            <span v-else></span>
          </template>
        </el-table-column>
        <el-table-column prop="remark" width="250px" label="未成功原因">
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange1"
        @current-change="handleCurrentChange1"
        :current-page="objBottom.pageNo"
        :page-size="objBottom.pageSize"
        layout="total, prev, pager, next"
        :total="total1"
      >
      </el-pagination>
      <span slot="footer" class="dialog-footer">
        <el-button @click="firstClassIsshow = false">取 消</el-button>
        <el-button type="primary" @click="firstClassIsshow = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <el-dialog title="请上传完成截图" :visible="screenshotShow" width="50%" @before-close="handlescreenshotCler">
      <el-upload
        class="avatar-uploader"
        ref="upload"
        action="#"
        :on-remove="handleRemove"
        :beforeUpload="beforeUpload"
        :file-list="fileList"
        :http-request="handleUpload"
        :auto-upload="true"
        :limit="1"
        drag
        accept=".png,.jpg,.pdf"
      >
        <img
          v-if="screenshot"
          :src="screenshot"
          style="width: 100%; height: 100%"
          class="avatar"
        />
        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
      </el-upload>

      <div class="dialog-footer" style="margin-top: 100px">
        <el-button @click="handlescreenshotCler" style="margin-right: 50px"
          >取 消</el-button
        >
        <el-button type="primary" @click="handlescreenshotSubmit"
          >确 定</el-button
        >
      </div>
    </el-dialog>

    <el-dialog :visible.sync="isShowImg" width="50%">
      <el-image v-if="isShowImg" :src="showImg"></el-image>
    </el-dialog>

    <el-dialog  title="详情"  :visible.sync="handleClickDetailShow" width="50%" :before-close="handleClickDetailClose">
       <div>
            <div style=" display: flex;">
              <div style="width: 10%;" >审批意见:</div>
              <div style="margin-left: 20px;width: 80%;text-align: start;" >{{handleClickDetailView}}</div>
            </div>
            <el-divider></el-divider>

            <div style=" display: flex;">
              <div style="width: 10%;" >预览图片:</div>
              <div style="margin-left: 20px;width: 80%;text-align: start;color:#007bff;" @click="handleUrls(handleClickDetailImg)">{{handleClickDetailImg}}</div>
            </div>
            <el-divider></el-divider>

        </div>
      </el-dialog>



  </div>
</template>

<script>
import {
  getList,
  getTeachers,
  changeFirstClass,
  getStudents,
  markeStatus,
  getSubject,
  getdeta,
  getStudentsType
} from "@/api/firstClassApi";
import { put, signatureUrl, getFileNameUUID } from "../../utils/oss";
import axios from "axios";
import apiBaseUrl from "../../../config/api";
import loadingUtils from "../../utils/loading";

export default {
  data() {
    return {
      isValidList:[
        {name:"有效", teacherId: 0},
        {name:"无效", teacherId: 1},
      ],
      isValid:'',
      marketArr_ss:[
      { value: 1, label: "规划" },
      { value: 2, label: "线下" },
      { value: 3, label: "纯补课" },
      ],
      dataTop: {
        xueguanshenhezhong: 0,
        teacherOk: 0,
        teacherNotOk: 0,
        teacherDaiTiJiao: 0,
        teacherBieBoHui: 0,
        marketOk: 0,
        marketNotOk: 0,
        firstOk: 0,
        firstNotOk: 0,
      },
      Time_start_end: [],
      Time_start_ends: [],
      screenshotShow: false,
      screenshot: "",
      fileList: [],
      content: "",
      tableData: [], //表格数据
      tableData1: [], //表格数据
      teacherArr: [], //所有老师
      teacherArrr:[],
      studentArr: [], //所有学生
      studentArr1: [], //所有学生
      subjectArr: [], //所有科目
      fileList: [],
      firstClassIsshow: false,
      firstClassState: [
        { value: 0, label: "未成功" },
        { value: 1, label: "已成功" },
        { value: null, label: "未知" },
        { value: 2, label: "全部" },
      ],
      planTeacher: [
        { value: 1, label: "未完成" },
        { value: 2, label: "已完成" },
      ],
      auditStatusArr: [
        { value: 0, name: "审核中" },
        { value: -1, name: "被驳回" },
        { value: -2, name: "待提交" },
        { value: 1, name: "已完成" },
      ],
      auditStatusArr_s: [
        { value: 0, name: "审核中" },
        { value: -1, name: "被驳回" },
        { value: 1, name: "已完成" },
        { value: -2, name: "待提交" },
      ],
      marketSuccessArr: [
        { value: 1, label: "未完成" },
        { value: 2, label: "已完成" },
      ],
      optionsListt111:[],
      optionsListt1111:[],
      SubjectGroupList: [],
      obj: {
        SubjectGroup: "",
        projectTeacherId:'',
        diagnoseTeacherId:'',
        marketSuccess: "", //销售完成情况
        auditStatus: "", //审核状态
        accomplish: "", //首次课教师计划完成情况
        classFirstDate: "", //首次课日期 搜索框
        teacherId: "", //教师Id 搜索框
        subject: "", //科目  搜索框
        studentId: "", //学生Id 搜索框
        // studentId1: "",
        id: "",
        // success: "",
        remark: "",
        pageNo: 1,
        pageSize: 10,
        classType:"",
        assistantId:'',
        regionName:'',
        isLose:'',
      },
      obj1:{
        success: ""
      },
      obj2:{
        studentId1:"",
        studentId:"",
      },
      itemObj: {},
      success: "",
      classFirstDate:[],
      objBottom: {
        classType:"",
        marketSuccess: "", //销售完成情况
        auditStatus: "", //审核状态
        accomplish: "", //首次课教师计划完成情况
        classFirstDate: "", //首次课日期 搜索框
        startTime:"",
        endTime:"",
        teacherId: "", //教师Id 搜索框
        subject: "", //科目  搜索框
        studentId: "", //学生Id 搜索框
        id: "",
        success: "",
        remark: "",
        pageNo: 1,
        pageSize: 10,
        assistantId:'',
      },
      detailDia: false,
      dialogVisible: false,
      flog: false,
      flogs: false,
      // firstClassTeaeh: [{value:}],
      total: 0, //总条数
      total1: 0,
      // paging: {//分页
      //   pageNo: 1,
      //   pageSize: 10,
      // },
      isShowImg:false,
      showImg:"",
      handleClickDetailShow: false,
      handleClickDetailImg:'',
      handleClickDetailView:'',

      optionsListt:[
        {dictValue:"北京", dictType:1 },
        {dictValue:"深圳", dictType:2 },
      ],

      adminType:'',

    };
  },
  created() {
    this.getListData();
    this.getTeacher();
    this.getStudent();
    this.getAllSubject();

    axios.get(`${ apiBaseUrl }/dict/getDictionary/${'地域'} `, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }).then((res)=>{ 
        this.optionsListt = res.data.data
    })
  },
  mounted(){

    let admin = JSON.parse(localStorage.getItem('admin'))
    this.adminType = admin.isRoot || ''

    this.optionsListt1111 = JSON.parse(sessionStorage.getItem('projectTeacherFindList'))
    this.optionsListt111 = JSON.parse(sessionStorage.getItem('diagnoseTeacherFindList'))
    this.SubjectGroupList = JSON.parse(sessionStorage.getItem('SubjectGroupList'))
    
  },

  methods: {
    handleClickDetailClose(){
      this.handleClickDetailShow = false
    },
    handleClickDetail(row){
      let { picture, remark, auditRemark } = row
      this.handleClickDetailView = auditRemark ? auditRemark : ''
      this.handleClickDetailImg = picture
      this.handleClickDetailShow = true
    },
    handleImgClick(row) {
      this.showImg = row;
      this.isShowImg = true;
    },
    //点击取消按钮
    handleClose() {
      this.flog = false;
      this.obj.remark = ""
      this.getListData1(0);
    },
    handleCloses() {
      this.flogs = false;
      this.obj.remark = ""
      this.getListData1(0);
    },
    //获取所有科目
    getAllSubject() {
      getSubject().then((res) => {
        this.subjectArr = res.data;
      });
    },
    getListData1(type) {

      

      // ========================================================添加开始——结束时间
      if(type == 1){
        this.obj.startTime = this.Time_start_end ? this.Time_start_end[0] : ""
        this.obj.endTime = this.Time_start_end  ? this.Time_start_end[1] : ""

        this.obj.createStartTime = this.Time_start_ends  &&  this.Time_start_ends.length > 0 ? this.Time_start_ends[0] + ' 00:00:00' : ""
        this.obj.createEndTime = this.Time_start_ends  &&  this.Time_start_ends.length > 0 ? this.Time_start_ends[1] + ' 23:59:59': ""

        let obj = this.obj1
        let data = Object.assign(obj,this.obj)

        // data.studentIds = this.obj.studentId + ',' + this.obj.studentId1

        let studentIds = ""
        if(this.obj2.studentId){
          studentIds = this.obj2.studentId + ''
          if(this.obj2.studentId1){
            studentIds =  this.obj2.studentId + ',' + this.obj2.studentId1
          }
        }else{
          if(this.obj2.studentId1){
            studentIds = this.obj2.studentId1  + ''
          }
        }
        if(studentIds){
           data.studentIds = studentIds
        }else{
          data.studentIds = ""
          
        }

        data.diagnoseTeacherId = this.obj.diagnoseTeacherId
        data.projectTeacherId = this.obj.projectTeacherId
        data.categoryIds = this.obj.SubjectGroup
        data.isLose = this.obj.isLose

        getList(data).then((res) => {
          this.tableData = res.data.page.records && res.data.page.records.map((itmes)=>{
            console.log(itmes.isValid,'itmes.isValid')
            itmes.isValid = itmes.isValid == 1 ? 1 : itmes.isValid == 2 ? 2 : 1
            return itmes
          });
          this.total = res.data.page.total;
          this.dataTop = res.data
          if(res.code == 200){
            this.$message.success('查询成功')
          }
        });
      }else{

        this.obj.startTime = this.Time_start_end ? this.Time_start_end[0] : ""
        this.obj.endTime = this.Time_start_end  ? this.Time_start_end[1] : ""

        this.obj.createStartTime = this.Time_start_ends  &&  this.Time_start_ends.length > 0 ? this.Time_start_ends[0] + ' 00:00:00' : ""
        this.obj.createEndTime = this.Time_start_ends  &&  this.Time_start_ends.length > 0 ? this.Time_start_ends[1] + ' 23:59:59': ""

        let data = Object.assign({success:2},this.obj)

        // data.studentIds = this.obj.studentId + ',' + this.obj.studentId1


        let studentIds = ""
        if(this.obj2.studentId){
          studentIds = this.obj2.studentId + ''
          if(this.obj2.studentId1){
            studentIds =  this.obj2.studentId + ',' + this.obj2.studentId1
          }
        }else{
          if(this.obj2.studentId1){
            studentIds = this.obj2.studentId1  + ''
          }
        }
        if(studentIds){
           data.studentIds = studentIds
        }else{
           data.studentIds = ""
        }

       data.categoryIds = this.obj.SubjectGroup
       data.isLose = this.obj.isLose

        getList(data).then((res) => {
          this.tableData = res.data.page.records && res.data.page.records.map((itmes)=>{
            console.log(itmes,'itmes.isValid')
            itmes.isValid = itmes.isValid == 1 ? 1 : itmes.isValid == 2 ? 2 : 1
            return itmes
          });
          this.total = res.data.page.total;
          this.dataTop = res.data
          if(res.code == 200){
            this.$message.success('查询成功')
          }
        });
      }
    },
    //获取表格数据
    getListData() {
      // this.obj.success = null;
      // ========================================================添加开始——结束时间
      this.obj.startTime = this.Time_start_end ? this.Time_start_end[0] : ""
      this.obj.endTime = this.Time_start_end  ? this.Time_start_end[1] : ""
      this.obj.createStartTime = this.Time_start_ends && this.Time_start_ends.length > 0  ? this.Time_start_ends[0] + ' 00:00:00' : ""
      this.obj.createEndTime = this.Time_start_ends &&  this.Time_start_ends.length > 0 ? this.Time_start_ends[1] + ' 23:59:59': ""

      let success = 2
      if(this.obj1.success === 0){
        success = this.obj1.success
      }else if(this.obj1.success === 1){
        success = this.obj1.success
      }else if(typeof this.obj1.success === "object"){
        success = this.obj1.success
      }else{
        success = 2
      }

     let dataList = {
        marketSuccess: this.obj.marketSuccess, //销售完成情况
        auditStatus: this.obj.auditStatus, //审核状态
        accomplish: this.obj.accomplish, //首次课教师计划完成情况
        classFirstDate: this.obj.classFirstDate, //首次课日期 搜索框
        teacherId: this.obj.teacherId, //教师Id 搜索框
        subject: this.obj.subject, //科目  搜索框
        studentId: this.obj.studentId, //学生Id 搜索框
        id: this.obj.id,
        remark: this.obj.remark,
        pageNo: this.obj.pageNo,
        pageSize: this.obj.pageSize,
        classType: this.obj.classType,
        assistantId: this.obj.assistantId,
        regionName: this.obj.regionName || localStorage.getItem('cityTepy'),
        isLose: this.obj.isLose
      }

      let data = Object.assign({success: success },dataList)

      // data.studentIds = this.obj.studentId + ',' + this.obj.studentId1

      let studentIds = ""
        if(this.obj2.studentId){
          studentIds = this.obj2.studentId + ''
          if(this.obj2.studentId1){
            studentIds =  this.obj2.studentId + ',' + this.obj2.studentId1
          }
        }else{
          if(this.obj2.studentId1){
            studentIds = this.obj2.studentId1  + ''
          }
        }
        if(studentIds){
           data.studentIds = studentIds
        }else{
          data.studentIds = ""
        }


      getList(data).then((res) => {
        // res.data.records.forEach((itme)=>{
        //   if(itme.success == null || itme.success == "" || itme.success == undefined || itme.success == "undefined"){
        //      itme.success = 2
        //   }
        // })
        this.tableData = res.data.page.records && res.data.page.records.map((itmes)=>{
            itmes.isValid = itmes.isValid == 1 ? 1 : itmes.isValid == 2 ? 2 : 1
            return itmes
          });
        this.total = res.data.page.total;
        this.dataTop = res.data
        if(res.code == 200){
           this.$message.success('查询成功')
        }
      });
    },
    //获取所有老师
    getTeacher() {
      axios.get(`${apiBaseUrl}/schedule/assistantList`,{ headers:{'authorization': sessionStorage.getItem('tokenInfo')}}).then(response => { this.teacherArrr = response.data.data;  })
      getTeachers().then((res) => {
        this.teacherArr = res.data;
      });
    },
    //获取所有学生
    getStudent() {
      // getStudents().then((res) => {
      //   this.studentArr = res.data;
      // });

      getStudentsType(2).then(res => {
        this.studentArr = res.data
      })
      getStudentsType(1).then(_res => {
        this.studentArr1 = _res.data
      })

    },
    //修改销售完成情况
    changeMarke(row) {
      if (row.auditStatus == -1 || row.auditStatus == -2) {
        this.$message({ message: "审核状态必须已完成", type: "warning" });
        row.marketSuccess = 1;
      } else {
        let type = row.marketSuccess;
        this.$confirm("此操作将修改销售完成情况, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.screenshotShow = true;
            this.screenshotRow = row;
            // markeStatus(row).then(res => {
            //   if (res.code == 200) {
            //     this.$message.success(res.message)
            //   } else {
            //     this.$message.error(res.message)
            //   }
            //   this.getListData()
            // })
          })
          .catch(() => {
            row.marketSuccess = type == 1 ? 2 : 1;
            this.$message({
              type: "warning",
              message: "已取消",
            });
          });
      }
    },

    handlescreenshotSubmit() {
      this.screenshotShow = false;
      let row = this.screenshotRow;
      row.url = this.screenshot;

      markeStatus(row).then((res) => {
        if (res.code == 200) {
          this.$message.success(res.message);
        } else {
          this.$message.error(res.message);
        }
        this.screenshot = "";
        this.fileList = [];
        this.getListData();
      });
    },
    handlescreenshotCler() {
      this.tableData.forEach((itme) => {
        if (itme.id == this.screenshotRow.id) {
          itme.marketSuccess = 1;
        }
      });
      this.screenshot = "";
      this.fileList = [];
      this.screenshotShow = false;
    },
    getFileName(name) {
      return name.substring(name.lastIndexOf("."));
    },
    beforeUpload(file) {
      // 限制上传类型
      const fileExtensions =
        this.getFileName(file.name) === ".bmp" ||
        this.getFileName(file.name) === ".tif" ||
        this.getFileName(file.name) === ".gif" ||
        this.getFileName(file.name) === ".pcx" ||
        this.getFileName(file.name) === ".svg" ||
        this.getFileName(file.name) === ".psd" ||
        this.getFileName(file.name) === ".webp" ||
        this.getFileName(file.name) === ".apng" ||
        this.getFileName(file.name) === ".ai" ||
        this.getFileName(file.name) === ".avif" ||
        this.getFileName(file.name) === ".png" ||
        this.getFileName(file.name) === ".pdf" ||
        this.getFileName(file.name) === ".jpg";
      //限制的上限为20M
      const max20M = file.size / 1024 / 1024 < 20;
      if (!fileExtensions) {
        this.$message.error("上传文件类型只能是 .png, .jpg, .pdf 格式!");
      }
      if (!max20M) {
        this.$message.error("上传文件大小不能超过 20MB!");
      }
      return fileExtensions && max20M;
    },
    handleUpload(option) {
      var obj = option.file.name;
      var index = obj.lastIndexOf(".");
      obj = obj.substring(index, obj.length);
      // 生成的文件名，保留文件后缀名，进行拼接
      let objName = getFileNameUUID() + this.getFileName(option.file.name);
      // 调用 ali-oss 中的方法,flieName是存放的文件夹名称，可自己定义
      put(`mz_pc/${objName}`, option.file).then((res) => {
        
        this.screenshot = res.url;
        // 上传成功之后，转换真实的地址
        signatureUrl(`mz_pc/${objName}`).then((res) => {
          
        });
      });
    },
    handleRemove(file, fileList) {
      this.fileList = fileList;
      this.screenshot = "";
    },

    handleStateChange1(row){
      let { isLose, id } = row
      let isLoseValue = isLose
      let data = { id, isLose }
      axios.post(`${apiBaseUrl}/firstRecord/updateLose`, data,{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo') } }).then(response => {
        if(response.data.code == 200){
          this.$message.success('修改成功')
          this.searchBtn()
        }else{
          this.$message.error(response.data.message)
          row.isLose = ''
        }
      }).catch(err => {
        this.$message.error('网络异常，请稍后重试')
        row.isLose = ''
      })
    },
    //修改状态
    handleStateChange(row) {

      this.obj.remark = "";
      if (row.success == 0) {
        this.flog = true;
        this.row = row
      } else {
        this.flogs = true;
        this.row = row
        // this.$confirm("此操作将修改首次课完成情况, 是否继续?", "提示", {
        //   confirmButtonText: "确定",
        //   cancelButtonText: "取消",
        //   type: "warning",
        // })
        //   .then(() => {
        //     changeFirstClass(row).then((res) => {
        //       if (res.code == 200) {
        //         this.$message.success(res.message);
        //       } else {
        //         this.$message.error(res.message);
        //       }
        //       this.getListData();
        //     });
        //   })
        //   .catch(() => {
        //     this.$message({
        //       type: "warning",
        //       message: "已取消",
        //     });
        //     row.success = null;
        //     this.getListData();
        //   });
      }
      this.obj.id = row.id;
      // this.obj.success = row.success;
      // this.obj.success = 2;

    },
    //原因保存
    saveRemark() {

      loadingUtils.startLoading();

      if(this.obj.remark){
        this.obj.success = 2
        this.row.remark = this.obj.remark
        changeFirstClass(this.row).then((res) => {
          if (res.code == 200) {
            this.$message.success(res.message);
            this.obj.success = 2
            this.getListData1(0);
            this.flog = false;
            this.flogs = false;
            this.obj.remark = ""
            loadingUtils.endLoading();
          } else {
            this.$message.error(res.message);
            loadingUtils.endLoading();
          }
        }).catch((err) => {
          this.$message.error(err);
          loadingUtils.endLoading();
        })
      }else{
        this.$message({
          type: "warning",
          message: "请输原因",
        });
        loadingUtils.endLoading();
      }


    },

    downloadBtn(){

      // this.obj.studentIds = this.obj.studentId + ',' + this.obj.studentId1


      let studentIds = ""
      if(this.obj2.studentId){
        studentIds = this.obj2.studentId + ''
        if(this.obj2.studentId1){
          studentIds =  this.obj2.studentId + ',' + this.obj2.studentId1
        }
      }else{
        if(this.obj2.studentId1){
          studentIds = this.obj2.studentId1  + ''
        }
      }

      if(studentIds){
        this.obj.studentIds = studentIds
      }else{
        this.obj.studentIds = ""
      }


      if(this.obj1.success === 0){
         this.obj.success = this.obj1.success
      }else if(this.obj1.success === 1){
         this.obj.success = this.obj1.success
      }else if(typeof this.obj1.success === "object"){
         this.obj.success = this.obj1.success
      }else{
        this.obj.success = 2
      }




      axios.post(`${apiBaseUrl}/firstRecord/excelFrist`, this.obj, { responseType: "blob",

          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }

    }).then((res) => {
          const blob = new Blob([res.data], { type: "application/vnd.ms-excel",});
          const downloadLink = document.createElement("a");
          downloadLink.href = URL.createObjectURL(blob);
          downloadLink.download = "首次课计划.xlsx";
          downloadLink.click();
          this.obj.success = 2
      });


    },


    handleUrl(url,name){
      const replacedString = url.replace('+', '%2B')
      var link = document.createElement('a')
      link.href = replacedString
      link.download = name
      link.style.display = 'none'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },

    handleUrls(url){
      const replacedString = url
      var link = document.createElement('a')
      link.href = replacedString
      link.download = url
      link.style.display = 'none'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },


    //搜索按钮
    searchBtn() {
      this.obj.pageNo = 1;


      if(this.obj1.success === 0){
        this.getListData1(1)
        this.obj1.success = 0
      }else if(this.obj1.success === 1){
        this.getListData1(1)
        this.obj1.success = 1
      } else if(typeof this.obj1.success === "object"){
         this.getListData1(1)
         this.obj1.success = null
      }else{
        this.getListData1(0)
        this.obj1.success = 2
      }


    },
    searchBtns() {
      this.objBottom.success = this.success === "" ? 8 : this.success;
      this.objBottom.startTime = this.classFirstDate[0]
      this.objBottom.endTime = this.classFirstDate[1]
      getList(this.objBottom).then((res) => {
        this.tableData1 = res.data.page.records;
        this.total1 = res.data.page.total;
      });
    },
    //清空按钮
    clearBtn() {
      this.isValid = ''
      this.obj.isLose = ''
      this.obj.marketSuccess = "";
      this.obj.auditStatus = "";
      this.obj.accomplish = "";
      this.obj.classFirstDate = "";
      this.obj.teacherId = "";
      this.obj.studentId = "";
      this.obj.studentIds = "";
      this.obj2.studentId = "";
      this.obj2.studentId1 = "";
      this.obj.subject = "";
      this.obj.classType = "";
      this.obj.assistantId = "";
      this.obj.SubjectGroup = ""

      this.obj.diagnoseTeacherId =  "";
      this.obj.projectTeacherId =  "";

      // this.obj.success = "";
      this.success = "";
      this.Time_start_end = [];
      this.Time_start_ends = [];

      this.obj1.success = "";
      this.obj.regionName = '';
      this.obj.pageNo =  1
      this.obj.pageSize =  10
      this.getListData1(0);
    },
    clearBtns() {
      this.objBottom.marketSuccess = "";
      this.objBottom.auditStatus = "";
      this.Time_start_ends = [];
      this.objBottom.accomplish = "";
      this.objBottom.classFirstDate = "";
      this.objBottom.assistantId = "";
      this.classFirstDate = []
      this.objBottom.startTime = ""
      this.objBottom.endTime = ""
      this.objBottom.teacherId = "";
      this.objBottom.studentId = "";
      this.objBottom.subject = "";
      this.objBottom.classType = "";
      this.success = "";
      this.objBottom.success = 8;
      getList(this.objBottom).then((res) => {
        this.tableData1 = res.data.page.records;
        this.total = res.data.page.total;
      });
    },
    //点击首次课历史记录
    historyBtn() {
      this.firstClassIsshow = true;
      this.objBottom.success = 8;
      getList(this.objBottom).then((res) => {
        this.tableData1 = res.data.page.records;
        this.total1 = res.data.page.total;
      });
    },
    //详情
    detail(id) {
      this.detailDia = true;
      getdeta(id).then((res) => {
        this.content = res.data.content;
        this.fileList = res.data.urlList;
      });
    },
    //下载
    download(index) {
      // link.href = window.URL.createObjectURL(blob);
      // const downloadLink = document.createElement("a");
      // downloadLink.href = URL.createObjectURL(this.fileList[index])
      // downloadLink.click()
      window.location.href = this.fileList[index];
    },
    //分页
    handleSizeChange(v) {
      this.obj.pageSize = v;
     this.obj.pageNo = v;
      let obj = this.obj1
        let data = Object.assign(obj,this.obj)

        // data.studentIds = this.obj.studentId + ',' + this.obj.studentId1

        let studentIds = ""
        if(this.obj2.studentId){
          studentIds = this.obj2.studentId + ''
          if(this.obj2.studentId1){
            studentIds =  this.obj2.studentId + ',' + this.obj2.studentId1
          }
        }else{
          if(this.obj2.studentId1){
            studentIds = this.obj2.studentId1  + ''
          }
        }
        if(studentIds){
           data.studentIds = studentIds
        }else{
          data.studentIds = ""
        }


        getList(data).then((res) => {
          this.tableData = res.data.page.records && res.data.page.records.map((itmes)=>{
            itmes.isValid = itmes.isValid == 1 ? 1 : itmes.isValid == 2 ? 2 : 1
            return itmes
          });
          this.total = res.data.page.total;
          this.dataTop = res.data
          if(res.code == 200){
            this.$message.success('查询成功')
          }
        });
    },
    handleCurrentChange(v) {

      

        this.obj.pageNo = v;
        let obj = this.obj1
        let data = Object.assign(obj,this.obj)




        if (data.success === null) {
          data.success = null;
        } else if (data.success === '' || data.success === undefined) {
          data.success = 2;
        }else{
          data.success = data.success
        }

        // data.studentIds = this.obj.studentId + ',' + this.obj.studentId1

        let studentIds = ""
        if(this.obj2.studentId){
          studentIds = this.obj2.studentId + ''
          if(this.obj2.studentId1){
            studentIds =  this.obj2.studentId + ',' + this.obj2.studentId1
          }
        }else{
          if(this.obj2.studentId1){
            studentIds = this.obj2.studentId1  + ''
          }
        }
        if(studentIds){
           data.studentIds = studentIds
        }else{
          data.studentIds = ""
        }


        getList(data).then((res) => {
          this.tableData = res.data.page.records && res.data.page.records.map((itmes)=>{
            itmes.isValid = itmes.isValid == 1 ? 1 : itmes.isValid == 2 ? 2 : 1
            return itmes
          });
          this.total = res.data.page.total;
          this.dataTop = res.data
          if(res.code == 200){
            this.$message.success('查询成功')
          }
        });
    },
    //分页
    handleSizeChange1() {},
    handleCurrentChange1(v) {
      this.objBottom.pageNo = v;
      this.searchBtns();
    },
  },
};
</script>

<style scope>
header {
  text-align: left;
}

.pending {
  text-align: left;
}

.pending p {
  font-size: 14px;
}

.pending_bottom {
  width: 100%;
  height: 140px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: space-around;
  border-radius: 10px;
}
.avatar-uploader >>> .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  margin-right: 88%;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.el-upload {
  border: 1px dashed #d9d9d9 !important;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.pending_item {
  width: 170px;
  height: 100px;
  border-radius: 10px;
}

.pending_item p {
  margin-top: 20px;
  margin-left: 25px;
}

.leave {
  background: linear-gradient(to right, #028bcf, #80d0f6);
}

.renew {
  background: linear-gradient(to right, #fdbe29, #fecf64);
}

.communication {
  background: linear-gradient(to right, #5d9656, #aac8a6);
}

.afterClass {
  background: linear-gradient(to right, #ff698a, #fe9f74);
}

.first {
  background: linear-gradient(to right, #d87ea3, #e3c5c6);
}

.classroom {
  background: linear-gradient(to right, #1da8aa, #94e0dd);
}

.issue {
  background: linear-gradient(to right, #f4ab56, #f6cd9e);
}

.demo-form-inline {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.demo-form-inline .el-form-item {
  margin-right: 30px;
}

/* 兼容移动端 */
@media screen and (max-width: 750px) {
  .fiveLessons {
    width: 1430px;
  }

  /* 兼容移动端 */
  #aa >>> .fiveLessons {
    width: 70% !important;
  }
}
.btns {
  background-color: #428bca;
  border-color: #428bca;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/manager/afterSales/fistClass.vue